export enum InvoiceType {
  Draft = 'Draft',
  Complete = 'Complete',
}

export default InvoiceType;
